/* eslint-disable camelcase */
import config from 'config';
import axios from '@mobile/util/axios';
import { authHeader } from '@mobile/services/user';
import {
    encodeFilters, encodeIssue, decodeIssue, decodeIssues,
} from '@/services/issue';

const issuesURL = `${config.apiUrl}/${config.apiVersion}/issues`;

const getAll = (
    url = issuesURL,
    filters = {},
) => axios.get(url, {
    headers: authHeader(),
    params: encodeFilters(filters),
}).then((response) => decodeIssues(response.data));

const get = (
    id = null,
    url = issuesURL,
) => {
    if (!id) throw new Error(window.i18n.t('You must provide an ID in order to fetch an issue'));
    return axios.get(
        `${url}/${id}`,
        { headers: authHeader() },
    ).then((response) => decodeIssue(response.data));
};

const getFilterOptions = () => axios.get(
    `${issuesURL}/filters`,
    { headers: authHeader() },
).then((response) => response.data);

const raise = (payload = {}) => axios.post(issuesURL,
    encodeIssue(payload),
    { headers: authHeader() }).then((response) => response.data);

const edit = (id, payload = {}) => {
    if (!id) throw new Error(window.i18n.t('You must provide an ID in order to edit an issue'));
    return axios.post(`${issuesURL}/${id}`,
        {
            ...encodeIssue(payload, id),
            _method: 'PUT',
        },
        { headers: authHeader() }).then((response) => response.data);
};

export default {
    get,
    getAll,
    getFilterOptions,
    raise,
    edit,
};
